import { render, staticRenderFns } from "./ShowModels.vue?vue&type=template&id=404a8012&scoped=true&"
import script from "./ShowModels.vue?vue&type=script&lang=js&"
export * from "./ShowModels.vue?vue&type=script&lang=js&"
import style0 from "./ShowModels.vue?vue&type=style&index=0&id=404a8012&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a8012",
  null
  
)

export default component.exports